var _path, _path2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7515 12.5056H13.7892C13.7892 15.6408 13.7892 19.5 13.7892 19.5H10.8813C10.8813 19.5 10.8813 15.6782 10.8813 12.5056H9.49902V10.0335H10.8813V8.43458C10.8813 7.28942 11.4255 5.5 13.8159 5.5L15.9707 5.50826V7.90791C15.9707 7.90791 14.6613 7.90791 14.4067 7.90791C14.1521 7.90791 13.7901 8.03521 13.7901 8.58131V10.034H16.0056L15.7515 12.5056Z",
    fill: "#222222"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_41",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 9,
    y: 5,
    width: 8,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7515 12.5056H13.7892C13.7892 15.6408 13.7892 19.5 13.7892 19.5H10.8813C10.8813 19.5 10.8813 15.6782 10.8813 12.5056H9.49902V10.0335H10.8813V8.43458C10.8813 7.28942 11.4255 5.5 13.8159 5.5L15.9707 5.50826V7.90791C15.9707 7.90791 14.6613 7.90791 14.4067 7.90791C14.1521 7.90791 13.7901 8.03521 13.7901 8.58131V10.034H16.0056L15.7515 12.5056Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_41)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.499023,
    y: 0.5,
    width: 24,
    height: 24,
    fill: "#222222"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/Facebook.2a81bbbf6ee7ff43c17f83bd47920d8b.svg";
export { ForwardRef as ReactComponent };